import React from 'react';

export class Renderers {
    constructor(enterEdit, exitEdit, editFieldName) {
        this.rowRender = this.rowRender.bind(this);
    }

    rowRender(trElement, dataItem, functionCallback) {
        const trProps = {
            ...trElement.props,
            onDoubleClick: () => {
              functionCallback("onDoubleClick", dataItem.dataItem);
            },
            onContextMenu : (e) => {
             // Dal�� eventy
             // functionCallback("onContextMenu", dataItem.dataItem);
            },
        };
        return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
    }
}



// WEBPACK FOOTER //
// ./src/components/common/GridRowRenderer.js